import { SvgIcon } from '@material-ui/core'

export default function HomeIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M13.3944 3.76097C12.412 2.74635 10.7847 2.74635 9.80232 3.76096L5.00385 8.71669C4.72826 9.00131 4.54308 9.36112 4.47162 9.75079C3.88886 12.9288 3.84584 16.1822 4.34438 19.3745L4.52088 20.5047C4.57663 20.8617 4.88409 21.1248 5.2454 21.1248H8.59836C8.8745 21.1248 9.09836 20.901 9.09836 20.6248V13.6248H14.0984V20.6248C14.0984 20.901 14.3222 21.1248 14.5984 21.1248H17.9513C18.3126 21.1248 18.62 20.8617 18.6758 20.5047L18.8523 19.3745C19.3508 16.1822 19.3078 12.9288 18.7251 9.75079C18.6536 9.36112 18.4684 9.00131 18.1928 8.7167L13.3944 3.76097Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
